import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import * as serviceWorker from './serviceWorker'
import 'antd/dist/antd.css'
import App from 'app/App'
import {PersistGate} from 'redux-persist/integration/react'
import {Spin} from "antd"
import configureStore from 'app/store'

function render() {
  const {store, persistor} = configureStore()

  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={<Spin tip="로딩 중"/>} persistor={persistor}>
        <App/>
      </PersistGate>
    </Provider>,
    document.getElementById('root')
  )
}

render()

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./app/App', render)
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
